import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-16abf3b2"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "member-box"
};
const _hoisted_2 = {
  class: "member-tit"
};
const _hoisted_3 = {
  class: "info-box"
};
const _hoisted_4 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "info-title"
}, "团队成员", -1));
const _hoisted_5 = ["onClick"];
const _hoisted_6 = ["src"];
const _hoisted_7 = {
  class: "name"
};
const _hoisted_8 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "info-line"
}, null, -1));
const _hoisted_9 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "info-title"
}, "发起人众筹履历", -1));
const _hoisted_10 = ["onClick"];
const _hoisted_11 = {
  class: "pro-item-info"
};
const _hoisted_12 = {
  class: "pro-item-info-top"
};
const _hoisted_13 = {
  class: "pro-item-info-name render-line-clamp"
};
const _hoisted_14 = ["src"];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_CompPopupBottom = _resolveComponent("CompPopupBottom");
  return _openBlock(), _createBlock(_component_CompPopupBottom, {
    show: $props.show,
    onOpen: $options.open
  }, {
    default: _withCtx(() => [_createElementVNode("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createTextVNode(_toDisplayString($data.title) + " ", 1), _createElementVNode("i", {
      class: "close",
      onClick: _cache[0] || (_cache[0] = (...args) => $options.closePopup && $options.closePopup(...args))
    })]), _createElementVNode("div", _hoisted_3, [_hoisted_4, (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.list, (item, index) => {
      return _openBlock(), _createElementBlock("div", {
        key: index,
        class: "list-item",
        onClick: $event => $options.toUserhome(item)
      }, [_createElementVNode("img", {
        class: "icon",
        src: item.icon
      }, null, 8, _hoisted_6), _createElementVNode("div", _hoisted_7, [_createElementVNode("span", null, _toDisplayString(item.username), 1), _createElementVNode("i", {
        class: _normalizeClass({
          'first': index == 0
        })
      }, _toDisplayString(item.role), 3)])], 8, _hoisted_5);
    }), 128)), $data.proList && $data.proList.length ? (_openBlock(), _createElementBlock(_Fragment, {
      key: 0
    }, [_hoisted_8, _hoisted_9, (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.proList, (item, index) => {
      return _openBlock(), _createElementBlock("div", {
        key: index,
        class: "pro-item",
        onClick: $event => $options.goProInfo(item.id)
      }, [_createElementVNode("div", _hoisted_11, [_createElementVNode("div", _hoisted_12, [_createElementVNode("span", null, _toDisplayString(item.start_time.split(' ')[0]) + " 发起项目", 1), _createElementVNode("span", {
        class: _normalizeClass(['status', {
          'status-success': item.status_code == 3
        }])
      }, _toDisplayString(item.status), 3)]), _createElementVNode("div", _hoisted_13, _toDisplayString(item.name), 1)]), _createElementVNode("img", {
        class: "logo",
        src: _ctx.$imgUrlFilter(item.logo, 160, 160)
      }, null, 8, _hoisted_14)], 8, _hoisted_10);
    }), 128))], 64)) : _createCommentVNode("", true)])])]),
    _: 1
  }, 8, ["show", "onOpen"]);
}